<template>
  <div class="index_two" style="margin-top: 0px;">
    <div class="index_titel">
      <b data-aos="fade">优势特点</b>
      <div data-aos="fade" data-aos-delay="100">多触点海外营销链路</div>
    </div>
    <div class="warp">
      <ul class="tab clearfix">
        <li class="active index_two_1">
          <em data-aos="fade" class="tabImg"
            ><img src="~@/assets/product/全面提效.png" alt="" />
            <div class="tabCon1">
              <p data-aos="fade-down">
                <i></i>
                外贸极客”集成了AIGC和AGI等前沿技术，自动生成多语种内容，智能化处理营销任务，极大提升您的营销效率。企业涵盖从发现潜在客户到完成销售的全流程，让您从繁琐的重复工作中解放出来，把精力集中于战略决策，让营销工作快人一步，效率倍增。
              </p>
            </div>
          </em>
          <span data-aos="fade">全面提效</span>
          <b data-aos="fade"> <img src="~@/assets/home/箭头1.png" alt="" /> </b>
        </li>
        <li class="index_two_2">
          <em data-aos="fade" class="tabImg"
            ><img src="~@/assets/product/精准降本.png" alt="" />
            <div class="tabCon1">
              <p>
                <i></i>
                面对数据解析和运营成本的头疼问题，“外贸极客”搭载了营销大数据平台，能即时捕捉全球市场动态，给出定制化营销解决方案，直观展现目标客户列表，帮助企业高效分配资源，节省成本同时又不失目标精准性。
              </p>
            </div>
          </em>
          <span data-aos="fade">精准降本</span>
          <b data-aos="fade"> <img src="~@/assets/home/箭头3.png" alt="" /> </b>
        </li>
        <li class="index_two_3">
          <em class="tabImg"
            ><img src="~@/assets/product/知先机得.png" alt="" />
            <div class="tabCon1">
              <p>
                <i></i>
                与时俱进的行业资讯和市场动态是企业不可或缺的资讯来源。“外贸极客”及时推送全球行业资讯，帮助您轻松掌握市场脉动，高效把握行业趋势，确保您在激烈的市场竞争中总能抢占先机。
              </p>
            </div>
          </em>
          <span>行业先机</span>
        </li>
        <li class="index_two_4">
          <em data-aos="fade" class="tabImg"
            ><img src="~@/assets/product/数字化管理.png" alt="" />
            <div class="tabCon1">
              <p>
                <i></i>
                对于期望数字化转型的企业，“外贸极客”提供一种前所未有的经验。无论是在内容创作、客户管理还是行业数据分析上，都通过高级算法和可视化工具赋予了企业数字化管理的新动力，让企业在数字化浪潮中乘风破浪。
              </p>
            </div>
          </em>
          <span data-aos="fade">数字化管理</span>
          <b data-aos="fade"> <img src="~@/assets/home/箭头3.png" alt="" /> </b>
        </li>
        <li class="index_two_5">
          <em class="tabImg">
            <img src="~@/assets/product/品牌生长.png" alt="" />
            <div class="tabCon1">
              <p>
                <i></i>
                “外贸极客”通过赋能营销新维度，结合智能Facebook、LinkedIn、WhatsApp运营，为您的品牌赢得广阔的社交空间和精准客群，助您的品牌在全球市场的每一个角落生长和扩展。
              </p>
            </div>
          </em>
          <span>品牌生长</span>
          <b> <img src="~@/assets/home/箭头2.png" alt="" /> </b>
        </li>
        <li class="index_two_6">
          <em class="tabImg"
            ><img src="~@/assets/product/承诺保障.png" alt="" />
            <div class="tabCon1">
              <p>
                <i></i>
                我们不仅仅提供产品，更有一系列周到的服务和保障。包括产品的后续优化、系统稳定性维护、客户成功团队的全方位支持，以及清晰可追溯的服务记录和详细的月报，确保您能放心使用且不断发现新价值。
              </p>
            </div>
          </em>
          <span>承诺保障</span>
          <b> <img src="~@/assets/home/箭头2.png" alt="" /> </b>
        </li>
        <li class="index_two_7">
          <em data-aos="fade" class="tabImg"
            ><img src="~@/assets/product/价值投资.png" alt="" />
            <div class="tabCon1">
              <p>
                <i></i>
                作为一个初创公司，我们了解创新产品初期带来的顾虑，但“外贸极客”正是一个低成入门的高价值投资。它能以远低于传统营销成本的投入，快速带来显着的市场回应和销售业绩，是开拓外贸市场的不二之选。
              </p>
            </div>
          </em>
          <span data-aos="fade">价值投资</span>
          <b data-aos="fade"> <img src="~@/assets/home/箭头5.png" alt="" /> </b>
        </li>
        <li class="index_two_8">
          <em data-aos="fade" class="tabImg"
            ><img src="~@/assets/product/简易接轨.png" alt="" />
            <div class="tabCon1">
              <p>
                <i></i>
                对于企业担心新旧系统的替换成本，“外贸极客”通过智能解析独立站或电子商务平台，并提供API接口对接现有CRM系统，确保平台切换高效且无缝衔接，降低了迁移换新的技术和时间成本。
              </p>
            </div>
          </em>
          <span data-aos="fade">简易接轨</span>
          <b data-aos="fade"> <img src="~@/assets/home/箭头4.png" alt="" /> </b>
        </li>
      </ul>
      <div class="tabCon">
        <dl class="clearfix">
          <dd>
            <a>
              <img src="~@/assets/home/数据决策.png" alt="" />
              <span>智能助手</span></a
            >
          </dd>
          <dd>
            <a>
              <img src="~@/assets/home/引流获客.png" alt="" />
              <span>经验策略</span></a
            >
          </dd>
          <dd>
            <a>
              <img src="~@/assets/home/智能营销1.png" alt="" />
              <span>建站推广</span></a
            >
          </dd>
          <dd>
            <a>
              <img src="~@/assets/home/外贸生态1.png" alt="" />
              <span>商机监控</span></a
            >
          </dd>
        </dl>
      </div>
    </div>

    <div class="index_two_btn" data-aos="fade-down">
      <a
        @click="showModal"
        data-source="p"
        onmouseover="linkDataSource(this)"
        a-type="register"
        target="_blank"
        rel="noopener noreferrer"
        class="btn_blue"
      >
        <span>免费试用</span></a
      >

      <a @click="showModal" class="btn_white">获取方案</a>
    </div>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
// import InquiryModalVue from "@/components/InquiryModal.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";
export default {
  components: {
    inquiryModalVue,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
      console.log(this.visible, "-----------");
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.tabCon dl{
  width: 640px;
  margin:0px auto;height: 100px;
  margin-top:35px;  padding-left:35px;
}
.tabCon dl dd{
  float: left;
  width:25%;
  text-align:center;
}
.tabCon dl dd a:hover{
  color:#fff;
  background:#2D97FF
}
.tabCon dl dd a img{
  padding-top:22px;
}
.tabCon dl dd a{
  line-height:26px;
 background: #C8DBFF;
opacity: 0.8;font-family: AlibabaPuHuiTiM, Alibaba-PuHuiTi;
color:#fff;
font-size: 14px;
width: 95px;
height:95px;
border-radius:50%;
display: block;
}
.tabCon dl dd a span{
  display: block;
}
 .index_two{
    height: 1050px;
    background: url('~@/assets/images/背景_全链路数字化出海解决方案.jpg') no-repeat center 80px;
    position: relative;
    margin-top: 100px;
}

  .index_two li{
    position: absolute;
    cursor: pointer;
  }
  .index_two li.index_two_2{
    left: 303px;
    top: -196px;
  }
  .index_two li.index_two_3{
    left: 303px;
    bottom:-396px
  }
  .index_two li.index_two_4{
    left: 736px;
    bottom: -4px;
  }
  .index_two ul.tab{
    position: relative;
    margin-top: 211px;
  }
  .index_two li span,.index_two li b{
    position: absolute;
    display: block;
    color: #2D97FF;
    font-size: 20px;
  }
  .index_two li.index_two_5{
    left: 736px;
    top: 196px;
  }
  .index_two li.index_two_6{
    right: 303px;
    bottom: -396px
  }
  .index_two li.index_two_7{
    right:303px;
    top: -196px
  }
  .index_two li.index_two_8{
    right:0px;
  }
  .index_two_1 b {
    top: -17px;
    left: 159px;
}
.index_two_2 b{
  top: 108px;
    left: 220px;

}
.index_two_4 b{
  top: 108px;
    left: 220px;
}
.index_two_7 b{
  top: 163px;
    left: 168px;
    transform: rotate(68deg);
    -webkit-transform: rotate(68deg);
}
.index_two_8 b{
  left: -108px;
    bottom: -51px;
}
.index_two_6 b{
  bottom: 64px;
    right: 218px;
}
.index_two_5 b{
  bottom: 64px;
    right: 218px;
}
.index_two li em img{
  width: 165px;
  transform: translateZ(0);
    transition: all 0.3s;
}
.index_two li:hover em img{
  transform: scale(1.25);
}

.index_two li span{
  top: 15px;
    left: -67px;
}
.index_two li.index_two_2 span{
  top: 15px;
    left: 156px;
    width: 130px;
}
.index_two li.index_two_4 span{
  top: 15px;
  left: 155px;
    width: 186px;
}
.index_two li.index_two_7 span{
  top: 15px;
    left: 156px;
    width: 130px;
}
.index_two li.index_two_8 span{
  top: 15px;
    left: 156px;
    width: 130px;
}

.tabCon{
  position: relative;
height:0.5px;
}
.tabImg {
  position: relative;
}
.tabImg:hover {
  .tabCon1{
    visibility: visible;
}
}
.tabCon1 {
  position: absolute;
  bottom: 110px;
  left: -40%;
  visibility: hidden;
  z-index: 99;
  p {
    font-size: 14px;
  color: #2B68FF;
  width: 300px;
  position: relative;
  background: #FFFFFF;
box-shadow: 0px 6px 13px 0px rgba(60,160,255,0.3000);
border: 1px solid #DCE6FF;
line-height: 22px;    border-radius: 8px;
padding:15px;
i{
  width: 10px;
    position: absolute;
    left: 50%;
    margin-left: -20px;
    bottom: -0.2rem;
    height: 10px;
    display: block;
    line-height: normal;
    border-color: #fff transparent transparent transparent;
    border-style: solid;
    border-width: 0.53333rem 0.53333rem 0 0.53333rem;
}
  }
}

.tabCon2{
    position: absolute;
    left: 284px;
    top: -340px;
}
.tabCon3{
    position: absolute;
   left: 295px;
    top: 66px;
}
.tabCon4{
    position: absolute;
    left: 704px;
    top: -340px;
}
.tabCon5{
    position: absolute;
   left:735px;
    top: 66px;
}
.tabCon6{
    position: absolute;
   right:305px;
    top: 66px;
}
.tabCon7{
    position: absolute;
   right:305px;
 top: -340px;
}
.tabCon8{
    position: absolute;
   right:5px;
 top: -130px;
}
.index_two .tabCon p{
  font-size: 14px;
  color: #2B68FF;
  width: 200px;
  position: relative;
  background: #FFFFFF;
box-shadow: 0px 6px 13px 0px rgba(60,160,255,0.3000);
border: 1px solid #DCE6FF;
line-height: 22px;    border-radius: 8px;
padding:15px;

}
.index_two .tabCon p i{
  width: 10px;
    position: absolute;
    left: 50%;
    margin-left: -20px;
    bottom: -0.2rem;
    height: 10px;
    display: block;
    line-height: normal;
    border-color: #fff transparent transparent transparent;
    border-style: solid;
    border-width: 0.53333rem 0.53333rem 0 0.53333rem;
}
.index_two_btn{
  width: 484px;
  bottom:100px;
  position: absolute;
  left: 50%;
  margin-left: -242px;
  a span {
    color: #fff;
  }
}
</style>
